
import React from 'react';
import SubLayout from '../../components/Layout/SubLayout.js';
import strings from "../../components/Language/index.js";

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData } from '../../components/Util/index.js';
import _ from 'lodash';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import { Button } from 'antd';
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";

class TutorialScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			lang: strings.getLanguage(),
			access_token: "",
			data: [],
			next_page_url: null,
			loading_view_btn: false,
			loading_download_btn: false,
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				this.setState({ access_token: token });
				this.getData(api.tutorial);
			});
		}
	}

	getData(API) {
		const { setLoading } = this.context;
		if (API === undefined || API === null || API === "" && !this.state.is_load) {
			return true;
		}
		var self = this;
		if (self.state.access_token) {
			setLoading(true);
			axios({
				method: 'GET',
				url: API,
				headers: {
					'Authorization': 'Bearer ' + self.state.access_token,
					'Content-Type': 'application/json',
					'Accept-Language': strings.getLanguage()
				}
			}).then(function (ress) {
				console.log("ress.data:::", ress.data);
				if (ress.data && ress.data.error === 200) {
					self.setState({
						data: (ress.data.data) ? [...self.state.data, ...ress.data.data] : self.state.data,
						next_page_url: (ress.data.data && ress.data.data.next_page_url) ? ress.data.data.next_page_url : null,
					});
				} else {
					if (ress.data.validation && ress.data.validation.length !== 0) {
						_.forEach(ress.data.validation, function (value) {
							if (value[0]) {
								toast.error(value[0]);
							}
						});
					} else {
						toast.error(ress.data.message);
					}
				}
				setLoading(false);
			}).catch(function (e) {
				setLoading(false);
			});
		}
	};


	/** 🔹 View PDF in a new tab */
	handleView = (pdfUrl) => {
		if (!pdfUrl) {
			toast.error("PDF not found!");
			return;
		}
		this.setState({ loading_view_btn: true });
		window.open(pdfUrl, "_blank", "noopener,noreferrer");
		setTimeout(() => {
			this.setState({ loading_view_btn: false });
		}, 1000);
	};

	/** 🔹 Download PDF file */
	handleDownload = async (pdfUrl, filename = "document.pdf") => {
		alert(pdfUrl)
		if (!pdfUrl) {
			toast.error("PDF not found!");
			return;
		}

		try {
			this.setState({ loading_download_btn: true });

			const response = await axios.get(pdfUrl, {
				responseType: "blob"
			});

			const blob = new Blob([response.data], { type: "application/pdf" });
			const downloadUrl = window.URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = downloadUrl;
			link.download = filename.endsWith(".pdf") ? filename : filename + ".pdf";
			document.body.appendChild(link);
			link.click();
			link.remove();

			window.URL.revokeObjectURL(downloadUrl);

			toast.success(strings.downloaded_successfully);
		} catch (error) {
			console.error("PDF download error:", error);

			if (error?.message?.includes("Network Error")) {
				toast.error("CORS error: The server does not allow PDF download.");
			} else {
				toast.error(strings.failed_to_download_PDF);
			}
		} finally {
			setTimeout(() => {
				this.setState({ loading_download_btn: false });
			}, 500); // small delay for smoother UX
		}
	};


	render() {
		return (
			<SubLayout data={{ "title": strings.tutorial }}>
				<div className='row justify-content-center' style={{ margin: 0, padding: 10 }}>
					<div className='col-md-4 offset-md-4' style={{ margin: 10, backgroundColor: "#1e2333", minHeight: "75vh", borderRadius: 10, paddingBlock: 20 }}>
						{this.state.data && this.state.data.length != 0 ?
							<>
								{this.state.data.map((item, i) =>
									<div key={i + 101} className="list_item">
										<div>{item[`title_${this.state.lang}`] || ""}</div>
										<div>
											<div className="col text-center" style={{}}>
												<Button
													className='btn rounded-sm btn-m login_button text-uppercase font-700 mt-2 mb-1 btn-full'
													onClick={() => this.handleView(item[`file_url_${this.state.lang}`] || "")}
													style={{ fontSize: 12, paddingBlock: 10, background: '#446CE3', color: "#FFF", width: "100%", borderRadius: 10, cursor: "pointer", opacity: (this.state.loading) ? 0.7 : 1, }}
													loading={this.state.loading_view_btn}
													icon={<EyeOutlined />}
												>
													<span style={{ marginLeft: 10 }}>{strings.view}</span>
												</Button>
											</div>
											<div className="col text-center" style={{}}>
												<a
													className='btn rounded-sm btn-m login_button text-uppercase font-700 mt-2 mb-1 btn-full'
													style={{ fontSize: 12, paddingBlock: 10, background: '#446CE3', color: "#FFF", width: "auto", borderRadius: 10, cursor: "pointer", opacity: (this.state.loading) ? 0.7 : 1, }}
													loading={this.state.loading_download_btn}
													href={item.file_url}
													download={item.title ? item.title + ".pdf" : "document.pdf"}
													icon={<DownloadOutlined />}
												>
													<span style={{ marginLeft: 10 }}>{(this.state.loading) ? strings.loading : strings.download}</span>
												</a>
											</div>
										</div>
									</div>
								)}
							</>
							:
							<div key={"i_" + 101} className="list_item">
								<div className='text-center'>{"Data not found!"}</div>
							</div>
						}

						{this.state.next_page_url ?
							<div className='flex-center' style={{ justifyContent: "center" }}>
								<Button onClick={() => this.getData(this.state.next_page_url)} type="primary" className='btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full '
									style={{ fontSize: 14, paddingBlock: 10, background: '#446CE3', color: "#FFF", borderRadius: 10 }}>
									{strings.Load_More}
								</Button>
							</div>
							: null}
					</div>
				</div>
			</SubLayout>
		);
	}
}
export default TutorialScreen;
